module.exports = __webpack_public_path__ + "img/avatar2.1aa494b2.png";